import { AlphaAddition } from "@pixelogicmedia/phelix_coredb_frontend";
import React from "react";
import { creationSource, getEnv, interceptor } from "../../helpers/utils";

const AddAlpha = ({ titleId }) => {
  const onAlphaSaved = (alpha, addAnother) => {
    let id = alpha.id;
    document.getElementById("alpha_id").value = id;
    document.getElementById("add_another_alpha").value = addAnother;
    const modal = document.getElementById("completeAlphaSavingModal");
    const triggerChange = (selector, value) => {
      const element = modal.querySelector(selector);
      element.value = value;
      const event = new Event("change", { bubbles: true });
      element.dispatchEvent(event);
    };
    triggerChange("#vendor_location_id", "");
    triggerChange("#alpha_status", 2);
    triggerChange("#user_ids", "");
    triggerChange("#distribution_type", "");

    document
      .querySelector(".complete-alpha-saving-modal")
      .classList.add("show");
    document.location.pathname = `/scheduler/titles/${titleId.split("-")[1]}`;
  };

  return (
    <div>
      <AlphaAddition
        creationSource={creationSource}
        titleId={titleId}
        alphaSaved={onAlphaSaved}
        axiosInstance={interceptor()}
        env={getEnv()}
      />
    </div>
  );
};

export default AddAlpha;
